export default {
	SubscriberConfig: {}
};
